module.exports = __webpack_public_path__ + "static/media/aboutUs-banner-fish.31792513.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/aboutUs/images/aboutUs-banner-fish.png
// module id = 110
// module chunks = 0